import { Injectable, Output, EventEmitter  } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { Page } from 'src/app/models/page.model';
import { environment } from 'src/environments/environment.prod'
import { HttpClient } from '@angular/common/http';
import { byPassJwToken } from 'src/app/services/common/interceptor.service'
import { RequestMessage } from '../../models/common/requestMessage.model';
import { Router } from '@angular/router';
import { MessagesService } from '../service.index';
// import { FavoriteService } from '../common/favorite.service';

@Injectable({
  providedIn: 'root',
})
export class PageService {
  pagesArray: Page[] = []
  listFavorite:any[];
  @Output() pageEmitter = new EventEmitter<Page>();
  @Output() tabEmitter = new EventEmitter<any>();
  @Output() ophpage = new EventEmitter<any>();
  @Output() eventOpenMenu = new EventEmitter<any>();

  httpOptions = {
    context: byPassJwToken()
  }
  sesion: any;
  browserName: string = '';
  constructor( 
    private http: HttpClient,
     private _router: Router,
     private _messagesService:MessagesService,
    //  private favoriteService:FavoriteService,
     private router: Router ) {
  }
  
  generarPage (nuevaPage : Page) {  
    // this._messagesService.loading();
    // const url = `${environment.urlValid}/fx/${nuevaPage.codProg}/@acceso`;
    // return this.http.post(url, {}, this.httpOptions).pipe(
    //   map((res: any) => {
    //     this._messagesService.close();
    //     if (!res.data.bloquea_forma) {
          this.pageEmitter.emit(nuevaPage);

          return null
    //     } else {
    //       this.pageEmitter.emit(res);
    //     }
    //     return res || {};
    //   },(error:any)=>{
    //     this._messagesService.close();

    //   })
    // )
  }
  generarPageOph (nuevaPageoph : Page) {
    this.pageEmitter.emit(nuevaPageoph);
  }

  // validarAccesoUrl(codProg : string) {
  //   const url = `${environment.urlValid}/fx/${codProg}/@acceso`;
  //   return this.http.post(url, {}, this.httpOptions);  
  // }

  // transformData(data: any, nameFunction: any, programaid?: string): Observable<any> { 
  //   const programID = programaid || data.qbe.programaid;
  //   return this.http.post<any>(`${environment.urlValid}/fx/${programID}/${nameFunction}`, data, this.httpOptions);
  // }

  // getUrlOdkl(request: RequestMessage):  Observable<string>{
  //   return this.http
  //   .post<string>(`${environment.urlApiMenuOphelia}/api/login/GetUrlOdkl`,request, this.httpOptions)
  //   .pipe(      
  //     catchError(err => of(''))
  //   );   
  // }

  // postDatapageOph(data : any):  Observable<any>{
  //   // this.sesion = token_sesio;
  //   return this.http
  //   .post<any>(`${environment.urlOpheliaview}/oviewer/ophpages`,data, this.httpOptions)
  //   .pipe(      
  //     catchError(err => of(''))
  //   );   
  // }

  // postDataSession(token_sesio: any,data : any):  Observable<any>{
  //   return this.http
  //   .post<any>(`${environment.urlOpheliaview}/oviewer/sesiones/${token_sesio}`,data, this.httpOptions)
  //   .pipe(      
  //     catchError(err => of(''))
  //   );   
  // }

  // getDataSession(token_sesio: any): Observable<any> {  
  //   return this.http.get(`${environment.urlOpheliaview}/oviewer/sesiones/${token_sesio}` );     
  // }

  // getDatapageOph(guid : any): Observable<any> {  
  //   return this.http.get(`${environment.urlOpheliaview}/oviewer/ophpages/${guid}` );     
  // }

  // getListpageOph(token_sesio: any): Observable<any> {  
  //   return this.http.get(`${environment.urlOpheliaview}/oviewer/ophpages/${token_sesio}` );     
  // }

  // DeleteListpageOphGeneral(token_sesio: any): Observable<any> {  
  //   return this.http.delete(`${environment.urlOpheliaview}/oviewer/ophpages/${token_sesio}` );     
  // }

  // DeleteListpageOph(token_sesio: any, guid : any): Observable<any> {  
  //   return this.http.delete(`${environment.urlOpheliaview}/oviewer/ophpages/${guid}` );     
  // }

  detectBrowserName() { 
    const agent = window.navigator.userAgent.toLowerCase();
    this.browserName = this.getValueBrowser(agent);
    return this.browserName;
  }

  getValueBrowser(agent:any){
    switch (true) {
      case agent.indexOf('edg') > -1:
        return  'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  // opheliaview(codProg : string) {
  //   return this.http.get(`${environment.urlSesio}/urlodkl/${codProg}`, this.httpOptions);    
  // }

  repaintTabs() {
    this.tabEmitter.emit(true);
  }

  OpenProgram(forma:any){
    const page: Page = {
      codProg: forma.cod_prog || forma.codigoPrograma,
      name: forma.nom_prog || forma.name,
      idForm: forma.idForm,
      id: 0,
      url: forma.url,
      cambiarUrl: true,
      lisnk:null
    }
    if(forma?.nom_fisi) page.url = forma.nom_fisi.toLowerCase();

     page.url = page.url + '&cod_prog=' + page.codProg;
    //  if (page.url.includes('.odkl') === true) {
    //   if (this.browserName !== 'edge') {
    //     this._messagesService.error(
    //       'Atención',
    //       'Para abrir programas ophelia utiliza Microsoft Edge',
    //       'warning'
    //     );
    //     return;
    //   } else {
    //     this.favoriteService.programaOpheliaEmiter.emit(page);
    //     return;
    //   }
    // }
    this.router.navigate(['/pageTabPanel']);
    this.generarPage(page);
  }
}
